if (!customElements.get('smooth-details')) {
    class SmoothDetails extends HTMLElement {
        summary;
        content;
        nameAttr = null;
        constructor() {
            super();
            const summary = this.querySelector('summary') || null;
            const content = this.querySelector('.accordion__content-wrapper') || null;
            if (!(summary instanceof HTMLElement) || !(content instanceof HTMLElement)) {
                throw new Error('SmoothDetails requires a <summary> and .accordion__content-wrapper');
            }
            this.summary = summary;
            this.content = content;
        }
        connectedCallback() {
            this.nameAttr = this.getAttribute('name');
            if (!this.summary || !this.content)
                return;
            // remember the name for “close others”
            this.summary.setAttribute('role', 'button');
            this.summary.setAttribute('tabindex', '0');
            this.content.setAttribute('role', 'region');
            // initial height + aria
            const isOpen = this.hasAttribute('open');
            this.updateAria(isOpen);
            this.content.style.height = isOpen ? `${this.content.scrollHeight}px` : '0px';
            this.content.style.padding = isOpen ? '' : '0px';
            this.content.style.overflow = 'hidden';
            this.content.style.transition = 'height 0.5s ease, padding 0.5s ease';
            // listen for clicks & keys on the summary
            this.summary.addEventListener('click', this.onSummaryClick);
            this.summary.addEventListener('keydown', this.onSummaryKeydown);
        }
        disconnectedCallback() {
            this.summary?.removeEventListener('click', this.onSummaryClick);
            this.summary?.removeEventListener('keydown', this.onSummaryKeydown);
        }
        /** Public no-arg toggle; safe to call from other code */
        toggle() {
            if (this.hasAttribute('open')) {
                this.close();
            }
            else {
                // before opening, close any siblings with the same name
                if (this.nameAttr) {
                    document.querySelectorAll(`smooth-details[name="${this.nameAttr}"]`).forEach((sibling) => {
                        if (sibling !== this && sibling.hasAttribute('open')) {
                            sibling.toggle();
                        }
                    });
                }
                this.open();
            }
            // let any icon-listeners know
            this.dispatchEvent(new Event('toggle', { bubbles: true }));
        }
        /** Expand this panel */
        open() {
            this.setAttribute('open', '');
            // animate height from 0 → full
            if (this.content) {
                this.content.style.height = `${this.content.scrollHeight}px`;
                this.content.style.padding = '';
            }
            this.updateAria(true);
            this.dispatchEvent(new Event('toggle', { bubbles: true }));
        }
        /** Collapse this panel */
        close() {
            this.removeAttribute('open');
            // animate height from whatever it is → 0
            // if it was “auto”, snap it first:
            if (this.content) {
                this.content.style.height = `${this.content.scrollHeight}px`;
                this.content.style.padding = '0px';
                // force reflow:
                if (this.content.offsetHeight) {
                    /* no-op */
                }
                this.content.style.height = '0px';
                this.content.style.padding = '0px';
            }
            this.updateAria(false);
            this.dispatchEvent(new Event('toggle', { bubbles: true }));
        }
        updateAria(isOpen) {
            this.summary?.setAttribute('aria-expanded', String(isOpen));
            this.content?.setAttribute('aria-hidden', String(!isOpen));
        }
        onSummaryClick = (e) => {
            e.preventDefault();
            this.toggle();
        };
        onSummaryKeydown = (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                this.toggle();
            }
        };
    }
    customElements.define('smooth-details', SmoothDetails);
}
